import { scrollAnimation } from './function/scroll-animation.js';
const tile = require('./lib/tile.js');
import '/assets/js/common.js';
import '/assets/css/common.scss';
import '/assets/css/about.scss';


// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimation({
  className: "outline",
  triggerPoint: 150,
});

scrollAnimation({
  className: "doctor__item",
  triggerPoint: 150,
});

scrollAnimation({
  className: "mission",
  triggerPoint: 150,
});


// ===========================================
// 歴史のレイアウト調整
// ===========================================
$(function () {
  let beforeWidth = $(window).width();

  function tileSet(item) {
    item.css({height: 'auto'});
    item.tile();

    $(window).on('resize', function(){
      if( $(window).width() !== beforeWidth ) {
        item.css({height: 'auto'});
        item.tile();
      }

      beforeWidth = $(window).width();
    });
  }

  tileSet( $('.historyList__item:nth-child(2n) .historyList__itemInner') );
});